import Cookies from 'universal-cookie';
import React from 'react';
import $ from 'jquery';
import { FieldTitle } from '../common/index';

class HiddenInput extends React.Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.state = {
      ip_of_user: '',
      browser_info: '',
      session_id: '',
      origin_uri: '',
      newsletter_subscription: 'true',
      newsletter_cancellation: 'true',
      newsletters_tagged_with: '',
      newsletter_selection: 'true',
      ga_source: '',
      ga_medium: '',
      ga_campaign: '',
      ga_keyword: '',
      ga_content: '',
      ga_tracking_id: '',
      target_bank_by_url_param: '',
      data_referrer: '',
      data_source: '',
      sugar_consultant_id: '',
      affiliate_s_id: '',
      affiliate_order_id: '',
      wellbeing_participant: ''
    };
  }

  /* eslint-disable complexity */
  componentDidMount() {
    switch (this.props.internalTitle) {
      case 'ip_of_user':
        this.getIp();
        break;
      case 'browser_info':
        this.getBrowserInfo();
        break;
      case 'session_id':
        this.getSessionId();
        break;
      case 'origin_uri':
        this.getOriginUri();
        break;
      case 'newsletter_subscription':
        break;
      case 'newsletter_cancellation':
        break;
      case 'newsletters_tagged_with':
        this.getNewsletterTag();
        break;
      case 'newsletter_selection':
        break;
      case 'target_bank_by_url_param':
        this.getValueByUrlParam(this.props.internalTitle, 'bank');
        break;
      case 'data_referrer':
        this.getValueByUrlParam(this.props.internalTitle, 'referrer');
        break;
      case 'data_source':
        this.getValueByUrlParam(this.props.internalTitle, 'source');
        break;
      case 'sugar_consultant_id':
        this.getValueByUrlParam(this.props.internalTitle, 'sugar_consultant');
        break;
      case 'consultant_id':
        this.getValueByUrlParam(this.props.internalTitle, 'consultant');
        break;
      case 'affiliate_s_id':
        this.setStateFromCookie('s_id', 'affiliate_s_id');
        break;
      case 'affiliate_order_id':
        break;
      case 'wellbeing_participant':
        this.setStateFromLocalStorage('participant_id', 'wellbeing_participant');
        break;
      default:
        this.getGoogleAnalyticsAndOtherUrlParams(this.props.internalTitle);
    }
  }
  /* eslint-enable complexity */

  setStateFromLocalStorage(key, stateField = key) {
    const value = localStorage.getItem(key);
    this.setState({ [stateField]: value || '' });
  }

  getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [cookieName, ...cookieParts] = cookie.trim().split('=');
      const cookieValue = cookieParts.join('=');
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
    return null;
  }

  setStateFromCookie(cookieName, stateField) {
    const value = this.getCookie(cookieName);
    this.setState({ [stateField]: value || '' });
  }

  getIp() {
    $.getJSON('https://api.ipify.org?format=jsonp&callback=?', (json) => {
      this.setState({ ip_of_user: json.ip });
    });
  }

  getBrowserInfo() {
    this.setState({ browser_info: navigator.userAgent });
  }

  getSessionId() {
    this.setState({ session_id: this.cookies.get('_quirinprivatbank_session_id') });
  }

  getOriginUri() {
    this.setState({ origin_uri: document.location.href });
  }

  getNewsletterTag() {
    const newsletterTag = this.props.options.value;

    this.setState({ newsletters_tagged_with: newsletterTag });
  }

  getValueByUrlParam(key, urlParamName) {
    const urlParams = new URLSearchParams(window.location.search);
    const urlParam = urlParams.get(urlParamName);

    if (urlParam) {
      this.setState({ [key]: urlParam });
    }
  }

  getGoogleAnalyticsAndOtherUrlParams(key) {
    const state = {};

    // if key contains "ga_" it is a google analytics parameter
    if (key.indexOf('ga_') === 0) {
      const method = key === 'ga_tracking_id' ? '_ga' : `_quirinprivatbank_${key}`;

      state[key] = this.cookies.get(method);

      // for external forms there are no cookies set, so we need to get the values from the url or
      // local storage
      if (!state[key]) {
        const urlParams = new URLSearchParams(window.location.search);
        const localStorage = window.localStorage;
        // the params are prefixed with `utm` instead of `ga`, what we use internally,
        // so we need to replace that when checking for the several keys,
        // e.g. `utm_source` instead of `ga_source`.
        // for `ga_keyword` it is not only replacing `ga` but a completely different `utm_term`.
        const keyForUrlParam = key === 'ga_keyword' ? 'utm_term' : key.replace('ga', 'utm');
        const urlParam = urlParams.get(keyForUrlParam) || localStorage.getItem(keyForUrlParam);

        if (urlParam) {
          state[key] = urlParam;
        }
      }

      this.setState(state);
    } else {
      this.getValueByUrlParam(key, key);
    }
  }

  render() {
    const { internalTitle, formId } = this.props;
    const contentArticleFormId = `content_article_form-${this.props.contentArticleFormId}`;
    const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;

    return (
      <div className="input hidden">
        <input type="hidden" name={internalTitle} id={forId} value={this.state[internalTitle]} />
      </div>
    );
  }
}

HiddenInput.propTypes = {
  internalTitle: React.PropTypes.string,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  options: React.PropTypes.object
};

export default HiddenInput;



// WEBPACK FOOTER //
// ./components/forms/hiddenInput.js